// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { BondConfig, BondConfigT, verifyBondConfig } from "./bond-config";
import { NicConfig, NicConfigT, verifyNicConfig } from "./nic-config";
import { RouteConfig, RouteConfigT, verifyRouteConfig } from "./route-config";
import { RuleConfig, RuleConfigT, verifyRuleConfig } from "./rule-config";
import { VlanConfig, VlanConfigT, verifyVlanConfig } from "./vlan-config";

/**
 * The whole site network as one value.
 *
 * A wrapper, not five parallel lists per carrier. The config is only ever
 * read and written as a unit — the wizard edits all of it at once, an edge
 * server applies all of it at once — and `LiftCloud` persists nested
 * structures as a single `FlatBuffer` blob in a `bytea` column, the way
 * adapters already store their `CDO` and `BACnet` configuration. Five lists
 * would need five columns and five converters, all saying one thing.
 *
 * A note on the doc comments in this file: the Rust generator backticks any
 * bare word that is also a field identifier anywhere in the include graph.
 * This file adds several very common English words as identifiers — among
 * them the ones a route and a rule are keyed by — so ordinary prose here and
 * in schemas that merely share the graph picks up stray backticks. It is
 * cosmetic and confined to generated Rust; the Go and TypeScript generators
 * leave prose alone. Said plainly rather than claimed to be avoided, because
 * an earlier version of this comment claimed avoidance and was mangled by the
 * very mechanism it described.
 */
export class SiteNetwork implements flatbuffers.IUnpackableObject<SiteNetworkT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SiteNetwork {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSiteNetwork(bb: flatbuffers.ByteBuffer, obj?: SiteNetwork): SiteNetwork {
    return (obj || new SiteNetwork()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsSiteNetwork(
    bb: flatbuffers.ByteBuffer,
    obj?: SiteNetwork,
  ): SiteNetwork {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SiteNetwork()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  nics(index: number, obj?: NicConfig): NicConfig | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new NicConfig()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  nicsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  bonds(index: number, obj?: BondConfig): BondConfig | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new BondConfig()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  bondsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  vlans(index: number, obj?: VlanConfig): VlanConfig | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new VlanConfig()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  vlansLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  routes(index: number, obj?: RouteConfig): RouteConfig | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new RouteConfig()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  routesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  rules(index: number, obj?: RuleConfig): RuleConfig | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset
      ? (obj || new RuleConfig()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  rulesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Reachability target the box probes before keeping a newly applied
   * network, reverting on failure. Without one a bad config cannot be rolled
   * back on a headless machine. Accepts "host", "host:port" and the
   * bracketed `[2001:db8::1]:443` form.
   */
  probeTarget(): string | null;
  probeTarget(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  probeTarget(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * CIDRs this box may hold an address in; anything outside quarantines the
   * interface rather than leaving the box live on an unknown VLAN.
   * Per-family — a family this list omits goes unenforced, because a SLAAC
   * prefix cannot be known in advance.
   */
  allowedCidrs(index: number): string;
  allowedCidrs(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  allowedCidrs(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  allowedCidrsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Resolvers. Empty leaves whatever the image or a lease supplies.
   *
   * A fully static site has no lease to inherit them from, and everything
   * the box then needs to reach — the tunnel host, the component registry —
   * is a hostname. Worse, a probe target given as a bare address still
   * answers, so the reachability check passes and a box that can route but
   * cannot resolve keeps the configuration instead of reverting.
   */
  nameservers(index: number): string;
  nameservers(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  nameservers(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  nameserversLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Search domains, paired with the resolvers above.
   */
  searchDomains(index: number): string;
  searchDomains(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  searchDomains(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  searchDomainsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startSiteNetwork(builder: flatbuffers.Builder) {
    builder.startObject(9);
  }

  static addNics(builder: flatbuffers.Builder, nicsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nicsOffset, 0);
  }

  static createNicsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startNicsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addBonds(builder: flatbuffers.Builder, bondsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, bondsOffset, 0);
  }

  static createBondsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startBondsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addVlans(builder: flatbuffers.Builder, vlansOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, vlansOffset, 0);
  }

  static createVlansVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startVlansVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addRoutes(builder: flatbuffers.Builder, routesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, routesOffset, 0);
  }

  static createRoutesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startRoutesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addRules(builder: flatbuffers.Builder, rulesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, rulesOffset, 0);
  }

  static createRulesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startRulesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addProbeTarget(builder: flatbuffers.Builder, probeTargetOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, probeTargetOffset, 0);
  }

  static addAllowedCidrs(builder: flatbuffers.Builder, allowedCidrsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, allowedCidrsOffset, 0);
  }

  static createAllowedCidrsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startAllowedCidrsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addNameservers(builder: flatbuffers.Builder, nameserversOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, nameserversOffset, 0);
  }

  static createNameserversVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startNameserversVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addSearchDomains(builder: flatbuffers.Builder, searchDomainsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, searchDomainsOffset, 0);
  }

  static createSearchDomainsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startSearchDomainsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endSiteNetwork(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createSiteNetwork(
    builder: flatbuffers.Builder,
    nicsOffset: flatbuffers.Offset,
    bondsOffset: flatbuffers.Offset,
    vlansOffset: flatbuffers.Offset,
    routesOffset: flatbuffers.Offset,
    rulesOffset: flatbuffers.Offset,
    probeTargetOffset: flatbuffers.Offset,
    allowedCidrsOffset: flatbuffers.Offset,
    nameserversOffset: flatbuffers.Offset,
    searchDomainsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    SiteNetwork.startSiteNetwork(builder);
    SiteNetwork.addNics(builder, nicsOffset);
    SiteNetwork.addBonds(builder, bondsOffset);
    SiteNetwork.addVlans(builder, vlansOffset);
    SiteNetwork.addRoutes(builder, routesOffset);
    SiteNetwork.addRules(builder, rulesOffset);
    SiteNetwork.addProbeTarget(builder, probeTargetOffset);
    SiteNetwork.addAllowedCidrs(builder, allowedCidrsOffset);
    SiteNetwork.addNameservers(builder, nameserversOffset);
    SiteNetwork.addSearchDomains(builder, searchDomainsOffset);
    return SiteNetwork.endSiteNetwork(builder);
  }

  unpack(): SiteNetworkT {
    return new SiteNetworkT(
      this.bb!.createObjList<NicConfig, NicConfigT>(this.nics.bind(this), this.nicsLength()),
      this.bb!.createObjList<BondConfig, BondConfigT>(this.bonds.bind(this), this.bondsLength()),
      this.bb!.createObjList<VlanConfig, VlanConfigT>(this.vlans.bind(this), this.vlansLength()),
      this.bb!.createObjList<RouteConfig, RouteConfigT>(
        this.routes.bind(this),
        this.routesLength(),
      ),
      this.bb!.createObjList<RuleConfig, RuleConfigT>(this.rules.bind(this), this.rulesLength()),
      this.probeTarget(),
      this.bb!.createScalarList<string>(this.allowedCidrs.bind(this), this.allowedCidrsLength()),
      this.bb!.createScalarList<string>(this.nameservers.bind(this), this.nameserversLength()),
      this.bb!.createScalarList<string>(this.searchDomains.bind(this), this.searchDomainsLength()),
    );
  }

  unpackTo(_o: SiteNetworkT): void {
    _o.nics = this.bb!.createObjList<NicConfig, NicConfigT>(
      this.nics.bind(this),
      this.nicsLength(),
    );
    _o.bonds = this.bb!.createObjList<BondConfig, BondConfigT>(
      this.bonds.bind(this),
      this.bondsLength(),
    );
    _o.vlans = this.bb!.createObjList<VlanConfig, VlanConfigT>(
      this.vlans.bind(this),
      this.vlansLength(),
    );
    _o.routes = this.bb!.createObjList<RouteConfig, RouteConfigT>(
      this.routes.bind(this),
      this.routesLength(),
    );
    _o.rules = this.bb!.createObjList<RuleConfig, RuleConfigT>(
      this.rules.bind(this),
      this.rulesLength(),
    );
    _o.probeTarget = this.probeTarget();
    _o.allowedCidrs = this.bb!.createScalarList<string>(
      this.allowedCidrs.bind(this),
      this.allowedCidrsLength(),
    );
    _o.nameservers = this.bb!.createScalarList<string>(
      this.nameservers.bind(this),
      this.nameserversLength(),
    );
    _o.searchDomains = this.bb!.createScalarList<string>(
      this.searchDomains.bind(this),
      this.searchDomainsLength(),
    );
  }

  unpackFields(...fields: string[]): SiteNetworkT {
    const t = new SiteNetworkT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("nics")) {
      t.nics = this.bb!.createObjList<NicConfig, NicConfigT>(
        this.nics.bind(this),
        this.nicsLength(),
      );
    }
    if (fieldSet.has("bonds")) {
      t.bonds = this.bb!.createObjList<BondConfig, BondConfigT>(
        this.bonds.bind(this),
        this.bondsLength(),
      );
    }
    if (fieldSet.has("vlans")) {
      t.vlans = this.bb!.createObjList<VlanConfig, VlanConfigT>(
        this.vlans.bind(this),
        this.vlansLength(),
      );
    }
    if (fieldSet.has("routes")) {
      t.routes = this.bb!.createObjList<RouteConfig, RouteConfigT>(
        this.routes.bind(this),
        this.routesLength(),
      );
    }
    if (fieldSet.has("rules")) {
      t.rules = this.bb!.createObjList<RuleConfig, RuleConfigT>(
        this.rules.bind(this),
        this.rulesLength(),
      );
    }
    if (fieldSet.has("probe_target")) {
      t.probeTarget = this.probeTarget();
    }
    if (fieldSet.has("allowed_cidrs")) {
      t.allowedCidrs = this.bb!.createScalarList<string>(
        this.allowedCidrs.bind(this),
        this.allowedCidrsLength(),
      );
    }
    if (fieldSet.has("nameservers")) {
      t.nameservers = this.bb!.createScalarList<string>(
        this.nameservers.bind(this),
        this.nameserversLength(),
      );
    }
    if (fieldSet.has("search_domains")) {
      t.searchDomains = this.bb!.createScalarList<string>(
        this.searchDomains.bind(this),
        this.searchDomainsLength(),
      );
    }
    return t;
  }
}

export class SiteNetworkT implements flatbuffers.IGeneratedObject {
  constructor(
    public nics: NicConfigT[] = [],
    public bonds: BondConfigT[] = [],
    public vlans: VlanConfigT[] = [],
    public routes: RouteConfigT[] = [],
    public rules: RuleConfigT[] = [],
    public probeTarget: string | Uint8Array | null = null,
    public allowedCidrs: string[] = [],
    public nameservers: string[] = [],
    public searchDomains: string[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const nics = SiteNetwork.createNicsVector(builder, builder.createObjectOffsetList(this.nics));
    const bonds = SiteNetwork.createBondsVector(
      builder,
      builder.createObjectOffsetList(this.bonds),
    );
    const vlans = SiteNetwork.createVlansVector(
      builder,
      builder.createObjectOffsetList(this.vlans),
    );
    const routes = SiteNetwork.createRoutesVector(
      builder,
      builder.createObjectOffsetList(this.routes),
    );
    const rules = SiteNetwork.createRulesVector(
      builder,
      builder.createObjectOffsetList(this.rules),
    );
    const probeTarget = this.probeTarget !== null ? builder.createString(this.probeTarget!) : 0;
    const allowedCidrs = SiteNetwork.createAllowedCidrsVector(
      builder,
      builder.createObjectOffsetList(this.allowedCidrs),
    );
    const nameservers = SiteNetwork.createNameserversVector(
      builder,
      builder.createObjectOffsetList(this.nameservers),
    );
    const searchDomains = SiteNetwork.createSearchDomainsVector(
      builder,
      builder.createObjectOffsetList(this.searchDomains),
    );

    return SiteNetwork.createSiteNetwork(
      builder,
      nics,
      bonds,
      vlans,
      routes,
      rules,
      probeTarget,
      allowedCidrs,
      nameservers,
      searchDomains,
    );
  }

  clone(): SiteNetworkT {
    const obj = new SiteNetworkT();
    obj.nics = this.nics.map((e) => e.clone());
    obj.bonds = this.bonds.map((e) => e.clone());
    obj.vlans = this.vlans.map((e) => e.clone());
    obj.routes = this.routes.map((e) => e.clone());
    obj.rules = this.rules.map((e) => e.clone());
    obj.probeTarget = this.probeTarget;
    obj.allowedCidrs = [...this.allowedCidrs];
    obj.nameservers = [...this.nameservers];
    obj.searchDomains = [...this.searchDomains];
    return obj;
  }

  equals(other: SiteNetworkT): boolean {
    if (this.nics.length !== other.nics.length) return false;
    for (let i = 0; i < this.nics.length; i++) {
      const a = this.nics[i];
      const b = other.nics[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.bonds.length !== other.bonds.length) return false;
    for (let i = 0; i < this.bonds.length; i++) {
      const a = this.bonds[i];
      const b = other.bonds[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.vlans.length !== other.vlans.length) return false;
    for (let i = 0; i < this.vlans.length; i++) {
      const a = this.vlans[i];
      const b = other.vlans[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.routes.length !== other.routes.length) return false;
    for (let i = 0; i < this.routes.length; i++) {
      const a = this.routes[i];
      const b = other.routes[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.rules.length !== other.rules.length) return false;
    for (let i = 0; i < this.rules.length; i++) {
      const a = this.rules[i];
      const b = other.rules[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.probeTarget !== other.probeTarget) return false;
    if (this.allowedCidrs.length !== other.allowedCidrs.length) return false;
    for (let i = 0; i < this.allowedCidrs.length; i++) {
      if (this.allowedCidrs[i] !== other.allowedCidrs[i]) return false;
    }
    if (this.nameservers.length !== other.nameservers.length) return false;
    for (let i = 0; i < this.nameservers.length; i++) {
      if (this.nameservers[i] !== other.nameservers[i]) return false;
    }
    if (this.searchDomains.length !== other.searchDomains.length) return false;
    for (let i = 0; i < this.searchDomains.length; i++) {
      if (this.searchDomains[i] !== other.searchDomains[i]) return false;
    }
    return true;
  }
}

export function verifySiteNetwork(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyNicConfig);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyBondConfig);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyVlanConfig);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyRouteConfig);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyRuleConfig);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        const len = verifier.checkVector(pos, 4);
        if (len > 0) {
          const vecStart = pos + verifier.readInt32(pos);
          const dataStart = vecStart + 4;
          for (let i = 0; i < len; i++) {
            const strPos = dataStart + i * 4;
            verifier.checkString(strPos);
          }
        }
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        const len = verifier.checkVector(pos, 4);
        if (len > 0) {
          const vecStart = pos + verifier.readInt32(pos);
          const dataStart = vecStart + 4;
          for (let i = 0; i < len; i++) {
            const strPos = dataStart + i * 4;
            verifier.checkString(strPos);
          }
        }
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        const len = verifier.checkVector(pos, 4);
        if (len > 0) {
          const vecStart = pos + verifier.readInt32(pos);
          const dataStart = vecStart + 4;
          for (let i = 0; i < len; i++) {
            const strPos = dataStart + i * 4;
            verifier.checkString(strPos);
          }
        }
      }
    }
  } finally {
    verifier.popDepth();
  }
}
